<template>
  <div id="merchandises" style="background-color: white">

    <div  class="content"   style="margin-bottom: 2rem;background-color: white">
      <div class="page-detail"  >
        <div class="content-block" >
          <div  style="margin-bottom:2rem;margin-top: 0.6rem ">
            <div  style="font-weight: bold;text-align: center;color: #00469A;
    font-size: 1.2rem;" >价格明细</div>
          </div>
          <hr />
          <div>
            <div  class="list-block" id="tab-detail" style="margin-top: 0rem;" >
              <div v-for="data in priceDetail" style="margin-bottom: 0.3rem;margin-top: 1.2rem;margin-left: 0.2rem;margin-right: 0.2rem" >
                <div>
                  <div >
                    <span style="color: #00469A">{{data.label}}</span>
                    <span style="float: right;">{{data.price}}</span>

                    <div style="margin-top: 1rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    mounted () {
      this.fetchData()
    },
    created () {
    },
    data () {
      return {
        priceDetail: []
      }
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      // '$route': 'fetchData'
    },
    computed: {
    },
    methods: {
      fetchData () {
        this.priceDetail = this.$route.query.priceDetails
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .gotopay{
    position: absolute;
    right: 0;
    background-color: #00469A;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -2.5rem;
    width: 5rem;
    height: 3rem;}
  .gotopay_button_style{
  @include sc(.7rem, #F6383A);
    font-weight: bold;
    color: #fff;

  }
  .list-block, .content-block {
    margin: 0.75rem 0;
  }
</style>



// WEBPACK FOOTER //
// CustPriceDetail.vue?0e0651c8